import { Layout } from "antd";
import styled from "styled-components";
import { Helmet } from "react-helmet";

const Content = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 400px) {
    padding: 16px 0px;
  }
`;

export const GuestLayout = ({ title, children }) => {
  return (
    <>
      <Helmet>
        <title>{title} | Bewell Warranty</title>
      </Helmet>
      <Content>{children}</Content>
    </>
  );
};
